


















































import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import {
  MUSIC_NATURE_SOUND_MIX_CREATE,
  MUSIC_NATURE_SOUND_MIX_EDIT,
} from "@/route-names";
import EventBus from "@models/eventBus";
import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import BackgroundMixResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundMixResponse";
import BackgroundFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileResponse";
import BackgroundFileTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileTranslationsRequest";
import { DragLiModel } from "@components/ui/models";
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class PageNatureSoundComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  columnNames = [
    "#",
    "Обложка",
    "Название",
    "Описание",
    "Содержимое микса",
    "",
    "",
  ];

  createRouteName = MUSIC_NATURE_SOUND_MIX_CREATE;
  editRouteName = MUSIC_NATURE_SOUND_MIX_EDIT;

  getDataFunc = this.$api.BackgroundFileService.getMixesAsync.bind(
    this.$api.BackgroundFileService
  );
  removeFunc = this.$api.BackgroundFileService.deleteMixAsync.bind(
    this.$api.BackgroundFileService
  );
  async created() {}
  async startDelete(item: BackgroundFilesGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  getMixesName(meditation: BackgroundMixResponse): string {
    const translations = meditation.BackgroundFiles.reduce(
      (a: BackgroundFileTranslationsRequest[], b: BackgroundFileResponse) => {
        return a.concat(b.Translations);
      },
      []
    );
    return translations.map((x) => `${x.LangCode}:${x.Name}`).join("\n");
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.BackgroundFileService.getMixesAsync(
        new FilterRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  SortIndex: index + 1,
                  Image: x.CoverImageUrl,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: t.Name,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.BackgroundFileService.changeMixSortIndexAsync(
        new ChangeSortIndexRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexRequest({
                Id: Number(x.Id),
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
